import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React from 'react';
import classnames from 'classnames';
import { string } from 'prop-types';
import { useTooltipState, TooltipWrapper, Tooltip, Icon } from '@tesla/design-system-react';
import Styles from '../SideNavigationBar.module.css.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var NavBarToolTip = function NavBarToolTip(_ref) {
  var icon = _ref.icon,
    label = _ref.label,
    iconImageUrl = _ref.iconImageUrl;
  var _useTooltipState = useTooltipState(),
    open = _useTooltipState.open,
    handlers = _useTooltipState.handlers,
    setExpanded = _useTooltipState.setExpanded,
    wrapperRef = _useTooltipState.wrapperRef;
  if (!label || !icon && !iconImageUrl) {
    return null;
  }
  var customHandlers = _objectSpread(_objectSpread({}, handlers), {}, {
    onClick: function onClick() {
      return setExpanded(false);
    }
  });
  var IconComp = iconImageUrl ? /*#__PURE__*/React.createElement("img", {
    alt: "".concat(label, " icon"),
    className: "tds-icon",
    src: "".concat(iconImageUrl, "#svgView(viewBox(0,0,24,24))")
  }) : /*#__PURE__*/React.createElement(Icon, {
    data: icon
  });
  return /*#__PURE__*/React.createElement(TooltipWrapper, _extends({}, customHandlers, {
    wrapperRef: wrapperRef,
    "data-test": "tooltip-wrapper"
  }), /*#__PURE__*/React.createElement("button", {
    className: classnames(Styles['tw-react--side-nav-bar--tooltip--icon']),
    type: "button"
  }, IconComp), /*#__PURE__*/React.createElement(Tooltip, {
    open: open,
    dense: true,
    align: "start",
    className: Styles['tw-react--side-nav-bar--tooltip--margin']
  }, /*#__PURE__*/React.createElement("p", {
    "data-test": "tooltip-copy"
  }, " ", label, " ")));
};
NavBarToolTip.propTypes = {
  icon: string,
  label: string,
  iconImageUrl: string
};
NavBarToolTip.defaultProps = {
  icon: '',
  label: '',
  iconImageUrl: ''
};

export { NavBarToolTip as default };
